import { gql } from 'urql';

const SubmitSuspiciousCardTransactionStatus = gql`
  mutation SubmitSuspiciousCardTransactionStatus(
    $input: SuspiciousCardTxnActionInput!
  ) {
    suspiciousCardTxnAction(input: $input) {
      ... on SuspiciousCardTxnActionApproveSuccess {
        __typename
        successTitle
        successMessage
      }
      ... on SuspiciousCardTxnActionDeclineSuccess {
        __typename
        cardId
        isReplaceable
      }
      ... on SuspiciousCardTxnActionError {
        __typename
        code
        title
        message
      }
    }
  }
`;
export default SubmitSuspiciousCardTransactionStatus;
